<template>
  <v-container
    fluid
    :class="BeyondSelected ? 'landingpage' : ''"
    style="min-height: 100vh; border-radius: 0"
  >
    <v-row
      align="center"
      class="fill-height"
      :class="{
        'justify-center': !BeyondSelected,
        'justify-left': BeyondSelected,
      }"
    >
      <v-col
        :cols="12"
        :sm="8"
        :md="6"
        :lg="6"
        :class="BeyondSelected ? 'beyond-margin' : ''"
      >
        <v-card
          fluid
          rounded="0"
          :class="BeyondSelected ? 'cardspace' : 'platnumcardspace'"
        >
          <v-toolbar flat color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="NewApp-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-form ref="form" v-model="startnewapp" id="startnewapp">
            <v-row>
              <v-col cols="12" offset-sm="1">
                <h3 style="color: #005f95; margin-top: 16px">
                  Please Select One Of The Following:
                </h3>

                <div class="newapp" style="margin-top: 16px">
                  <v-dialog v-model="newapp_dialog" persistent max-width="600">
                    <template v-slot:activator="{ on }">
                      <a
                        id="newapp"
                        v-bind="on"
                        @click="newapp_dialog = true"
                        v-on:click="destroysessions"
                        style="color: #005f95; cursor: pointer"
                        >- Start New</a
                      >
                    </template>

                    <v-card style="border-radius: 0">
                      <v-toolbar color="#005F95">
                        <v-toolbar-title row wrap
                          ><p class="Supporting-Docs">
                            SUPPORTING DOCUMENTS
                          </p></v-toolbar-title
                        >
                      </v-toolbar>

                      <v-card-text align:left
                        ><p>
                          Please ensure that you have ready the following
                          documents that are required in support of your
                          application:<br /><v-container justify-center>
                            • Identity Document <br />
                            • Proof Of Residence e.g. Utility Bill (Not Older
                            Than 3 Months)<br />
                            • A Minimum Of 3 Months Bank Statement<br />
                            • Latest Payslip<br />
                            • If You Have Your Own Business an ITA 34 Tax
                            Assessment form is required
                          </v-container>
                        </p></v-card-text
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <router-link to="singlequote">
                          <v-row>
                            <v-col cols="12" sm="1">
                              <v-btn
                                color="#005F95"
                                class="white--text"
                                text
                                @click="newapp_dialog = false"
                                >OK</v-btn
                              >
                            </v-col>
                          </v-row>
                        </router-link>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="login_dialog" persistent max-width="600">
                    <template v-slot:activator="{ on }">
                      <a
                        v-bind="on"
                        @click="login_dialog = true"
                        v-on:click="continueapp()"
                        style="color: #005f95; cursor: pointer"
                        ><br />
                        - Continue Saved Application </a
                      ><br />
                      <a
                        @click="login_dialog = true"
                        href="https://addonapplication.dinersclub.co.za/#/"
                        style="text-decoration: none; color: #005f95"
                        >- Personal Add-on Application</a
                      >
                    </template>
                    <v-card>
                      <v-toolbar color="#005F95">
                        <v-toolbar-title row wrap
                          ><p class="Supporting-Docs">
                            SUPPORTING DOCUMENTS
                          </p></v-toolbar-title
                        >
                      </v-toolbar>
                      <v-card-text
                        ><p>
                          Please ensure that you have ready the following
                          documents that are required in support of your
                          application:<br /><v-container>
                            • Identity Document<br />
                            • Proof Of Residence e.g. Utility Bill (Not Older
                            Than 3 Months)<br />
                            • A Minimum Of 3 Months Bank Statement<br />
                            • Latest Payslip<br />
                            • If You Have Your Own Business an ITA 34 Tax
                            Assessment form is required
                          </v-container>
                        </p></v-card-text
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <router-link to="UserLogin">
                          <v-btn
                            color="#005F95"
                            class="white--text"
                            align-center
                            @click="login_dialog = false"
                            >OK</v-btn
                          > </router-link
                        ><br />
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" lg="6" offset-md="4" offset-lg="5">
                <v-card id="insidecard">
                  <v-container grid-list-xs>
                    <h3 style="color: #005f95; margin-bottom: 16px">
                      Join The Club To Get Access To:
                    </h3>

                    <p class="mb-3">Transacting worldwide</p>
                    <p class="mb-3">A world class loyalty programme</p>
                    <p class="mb-0">Comprehensive travel benefits</p>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, watchEffect } from "vue";
import { useRoute } from "vue-router";

const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
// const isLarge = lgAndUp;

const newapp_dialog = ref(false);
const login_dialog = ref(false);
const startnewapp = ref("");

const route = useRoute();
const BeyondSelected = ref(false);
const ShariahSelected = ref(false);
const PlatinumSelected = ref(false);
const product = ref("");
const prodtype = ref("");

const map = {
  beyond: { flag: BeyondSelected, label: "BEYOND CARD" },
  shariah: { flag: ShariahSelected, label: "SHARI'AH CARD" },
  platinum: { flag: PlatinumSelected, label: "CREDIT CARD" },
};

watchEffect(() => {
  console.log("Fisrt Console Log");
  sessionStorage.clear();
  const slug = (route.path.replace("/", "") || "platinum").toLowerCase();
  BeyondSelected.value = ShariahSelected.value = PlatinumSelected.value = false;
  const cfg = map[slug] || map.platinum;
  cfg.flag.value = true;
  product.value = cfg.label;
  prodtype.value = slug;
  sessionStorage.setItem("prodtype", slug);
});

// onBeforeMount(() => {
// Destroy session and clear sessionStorage
// sessionStorage.clear();
//   // console.log(window.location);

//   // Logic for checking the URL and setting product type

//   // if (
//   //   window.location.pathname.includes("beyond") ||
//   //   window.location.pathname.includes("Beyond")
//   // ) {
//   //   BeyondSelected.value = true;
//   //   product.value = "BEYOND CARD";
//   //   sessionStorage.setItem("prodtype", "beyond");
//   //   prodtype.value = sessionStorage.getItem("prodtype");
//   // } else if (
//   //   window.location.pathname.includes("Shariah") ||
//   //   window.location.pathname.includes("shariah")
//   // ) {
//   //   ShariahSelected.value = true;
//   //   product.value = "SHARI'AH CARD";
//   //   sessionStorage.setItem("prodtype", "shariah");
//   //   prodtype.value = sessionStorage.getItem("prodtype");
//   // } else {
//   //   // BeyondSelected.value = true;
//   //   // product.value = "BEYOND CARD";
//   //   // sessionStorage.setItem("prodtype", "beyond");
//   //   // prodtype.value = sessionStorage.getItem("prodtype");

//   //   PlatinumSelected.value = true;
//   //   product.value = "CREDIT CARD";
//   //   sessionStorage.setItem("prodtype", "platinum");
//   //   prodtype.value = sessionStorage.getItem("prodtype");

//   //   // ShariahSelected.value = true;
//   //   // product.value = "SHARI'AH CARD";
//   //   // sessionStorage.setItem("prodtype", "shariah");
//   //   // prodtype.value = sessionStorage.getItem("prodtype");
//   // }

//   console.log(product.value);
//   console.log(prodtype.value);
// });

// Refs for session management
// const refNumber = ref("");
const apptype = ref("");

// Use Vue Router
// const router = useRouter();

// Function to set the application type for a new app
const destroysessions = () => {
  sessionStorage.setItem("apptype", "newapp");
};

// Function to set the application type for continuing an app
const continueapp = () => {
  sessionStorage.setItem("apptype", "continueapp");
  apptype.value = "continueapp";
};

console.log(apptype.value);

// Function to get a reference number

/* const getRefNumber = async () => {
  try {
    const response = await axios.post("/getRefNumber", {});
    if (response.data.data._RESPONSE === "SUCCESS") {
      if (response.data.data._REFNUMBER !== "") {
        sessionStorage.setItem("refNumber", response.data.data._REFNUMBER);
        refNumber.value = response.data.data._REFNUMBER;
      }
    }
  } catch (error) {
    console.error(error);
  }
}; */
</script>

<style scoped>
#heading {
  padding: 3%;
}

#insidecard {
  text-align: left;
  border: 5px solid white; /* Change color and thickness */
  border-radius: 0px; /* Optional: Add rounded corners */
  margin-bottom: 7%;
}
@font-face {
  font-family: "GathamBookLandingPage";
  src: url("@/assets/fonts/Gotham-Book.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Book.otf") format("opentype");
  font-display: swap;

  font-weight: normal;
  font-style: normal;
}
.NewApp-Toolbar {
  font-family: "GathamBookLandingPage";
  /* font-size: 30px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  padding: 16px;
}

.landingpage {
  background: url("@/assets/images/BeyondBI.jpeg") no-repeat center center;
  background-size: cover;
}

/* .transparent {
  background-color: transparent;
} */

.cardspace {
  margin-bottom: 500px;
}

.platnumcardspace {
  margin-top: 30px;
}

@media (min-width: 1280px) {
  .beyond-margin {
    margin-left: 40px; /* adjust this value as needed */
  }
}
</style>
